import React, { useEffect, useMemo, useRef, useState } from 'react';

/**
 * Searchable country picker for admin forms (full ISO list from API).
 */
const SearchableCountrySelect = ({
  countries,
  value,
  onChange,
  disabled,
  placeholder = 'Search country…',
}) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const rootRef = useRef(null);

  const selected = useMemo(() => countries.find((c) => c.id === value), [countries, value]);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return countries;
    return countries.filter(
      (c) => c.name.toLowerCase().includes(s) || (c.code || '').toLowerCase().includes(s),
    );
  }, [countries, q]);

  useEffect(() => {
    if (!open) return;
    const fn = (e) => {
      if (!rootRef.current?.contains(e.target)) {
        setOpen(false);
        setQ('');
      }
    };
    document.addEventListener('mousedown', fn);
    return () => document.removeEventListener('mousedown', fn);
  }, [open]);

  return (
    <div ref={rootRef} style={{ position: 'relative' }}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => !disabled && setOpen((o) => !o)}
        className="btn"
        style={{
          width: '100%',
          textAlign: 'left',
          background: '#fff',
          border: '1px solid #ccc',
          padding: '10px 12px',
          borderRadius: 8,
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
        }}
      >
        {selected ? `${selected.name} (${selected.code})` : placeholder}
      </button>
      {open ? (
        <div
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            top: '100%',
            zIndex: 50,
            marginTop: 4,
            background: '#fff',
            border: '1px solid #ddd',
            borderRadius: 8,
            boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
            maxHeight: 280,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <input
            type="search"
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Filter…"
            style={{
              border: 'none',
              borderBottom: '1px solid #eee',
              padding: '10px 12px',
              outline: 'none',
              fontSize: 14,
            }}
          />
          <ul style={{ listStyle: 'none', margin: 0, padding: 0, overflowY: 'auto', flex: 1 }}>
            {filtered.length === 0 ? (
              <li style={{ padding: 12, color: '#888' }}>No matches</li>
            ) : (
              filtered.map((c) => (
                <li key={c.id}>
                  <button
                    type="button"
                    onClick={() => {
                      onChange(c.id);
                      setOpen(false);
                      setQ('');
                    }}
                    style={{
                      width: '100%',
                      textAlign: 'left',
                      padding: '10px 12px',
                      border: 'none',
                      background: c.id === value ? '#f5eef2' : '#fff',
                      cursor: 'pointer',
                      fontSize: 14,
                    }}
                  >
                    <strong>{c.name}</strong>
                    <span style={{ color: '#888', marginLeft: 8 }}>{c.code}</span>
                  </button>
                </li>
              ))
            )}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default SearchableCountrySelect;
